<template>
  <div refs="missionName" class="mission-name">
    <span>Misja:</span>
    <p>
      <slot name="mission"></slot>
      <span class="gamename"><slot name="title"></slot></span>
    </p>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {TimelineLite} from "gsap";

export default {
  name: "MoleculeMissionName",
  computed: {
    ...mapGetters(['hangmanGame']),
  },
  mounted() {
    const timeline = new TimelineLite()
    const { missionName } = this.$refs
    timeline
        .to(missionName,  { x: 0, y:100, rotation: 0 })
  }

}
</script>
